import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Session token lives in sessionStorage so it auto-clears on tab/window close.
// (Per-tab semantics also support single-device session policy.)
export const TOKEN_KEY = "dw_token";
export const USER_KEY = "dw_user";

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const detail = err?.response?.data?.detail;
      // Clean local credentials
      sessionStorage.removeItem(TOKEN_KEY);
      sessionStorage.removeItem(USER_KEY);
      // If session was invalidated by another device, redirect with a flag the login page reads.
      // Avoid redirect loops when we're already on /login.
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        const reason = detail === "SESSION_INVALIDATED" ? "session_invalidated" : "expired";
        // Use sessionStorage to convey reason to /login (cleared after toast is shown)
        sessionStorage.setItem("dw_logout_reason", reason);
        window.location.replace("/login");
      }
    }
    return Promise.reject(err);
  }
);

export default api;
